import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  ActionType,
  IConsentStatementResponse,
} from "models/consentStatement/getConsentStatement";
import { httpStatus } from "configs/httpStatus";
import { getConsentStatement } from "services/consentStatement";
import {
  handleSuccessAction,
  handleErrorAction,
} from "./getConsentStatementActions";

function* consentStatementSaga() {
  try {
    const response: IConsentStatementResponse = yield call(getConsentStatement);
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccessAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onGetConsentStatementWatcher() {
  yield takeLatest(
    ActionType.GET_CONSENT_STATEMENT as any,
    consentStatementSaga
  );
}

export default [fork(onGetConsentStatementWatcher)];
